"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledRightRailFlyout = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject;

var _default = {};
exports["default"] = _default;

var StyledRightRailFlyout = _styledComponents["default"].section.withConfig({
  displayName: "RightRailFlyoutstyles__StyledRightRailFlyout",
  componentId: "sc-p8x386-0"
})(["", " top:60%;", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    z-4 block fixed right-0\n    ", ";\n  "])), function (_ref) {
  var _ref$theme = _ref.theme;
  _ref$theme = _ref$theme === void 0 ? {} : _ref$theme;
  var appearance = _ref$theme.rightRailFlyout.appearance;
  return "\n      ".concat(appearance, "\n    ");
}), function (_ref2) {
  var nodeWidth = _ref2.nodeWidth,
      squareWidth = _ref2.squareWidth;
  return nodeWidth && "\n      right: -".concat(nodeWidth - squareWidth, "px;\n      width: ").concat(nodeWidth, "px;    \n  ");
});

exports.StyledRightRailFlyout = StyledRightRailFlyout;